import { render, staticRenderFns } from "./AjaxForm.vue?vue&type=template&id=5ccedaa6&"
import script from "./AjaxForm.vue?vue&type=script&lang=js&"
export * from "./AjaxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports